export const programasArray = [
  {
    programa: 'Bitácora Ambiental del Estado de Hidalgo',
    links: [
      {
        label: 'Ir a la página',
        url: 'https://bitacora.semarnath.gob.mx'
      }
    ]
  },
  {
    programa: 'Monitoreo de la Calidad del Aire del Estado de Hidalgo',
    links: [
      {
        label: 'Ir a la página',
        url: 'https://www.aireysalud.semarnath.gob.mx'
      }
    ]
  },
  {
    programa: 'Programa de Verificación Vehicular',
    links: [
      {
        label: 'Ir a la página',
        url: 'https://verificacionvehicular.semarnath.gob.mx'
      }
    ]
  }, 
  {
    programa: 'Observatorio Estatal Hídrico',
    links: [
      {
        label: 'Ir a la página',
        url: 'https://observatorio.estatal.hidrico.semarnath.gob.mx/'
      }
    ]
  },
  {
    programa: 'Programa de Conservación de Ecosistemas en las Áreas Naturales Protegidas',
    links: [
      {
        label: 'Reglas de Operación',
        url: '/pdf/ROP-PCEANP-2026_ene_31.pdf'
      },
      {
      "label": "Anexos",
      "url": "/pdf/Anexos-PCEANP.pdf"
    }, 

    {
      "label": "Convocatoria",
      "url": "/pdf/ConversacionEcosistemas.pdf"
    }, 

    {
      "label": "Bases de Convocatoria",
      "url": "/pdf/BasesdeConvocatoria.pdf"
    }, 
    ]
    
  }
];
